export default __webpack_public_path__ + "static/media/24-3.312bb62d.mp3";